import { EServiceType } from '../../redux/reducers/publishTerms/types/serviceType';

const SERVICE_TYPES: { [key: string]: EServiceType } = {
  Top3: EServiceType.top3,
  PremiumObject: EServiceType.premium,
  DebitObject: EServiceType.paid,
  FreeObject: EServiceType.free,
  auction: EServiceType.auction,
};

export const mapServiceType = (serviceType: string): EServiceType | undefined => {
  return SERVICE_TYPES[serviceType];
};
